import {AppEnum} from "@/enums/AppEnum";
import SimpleText from "@/components/texts/simpleText";
import styled from "styled-components";
import Cookie from "@/utils/cookies"
import {SET_USER_STEP} from "@/store/slices/appSlice";
import {SET_USER} from "@/store/slices/userSlice";
import {useDispatch, useSelector} from "react-redux";
import Icon from "@mdi/react";
import {mdiFacebook} from "@mdi/js";
import Image from "next/image";
import themes from "@/styles/themes";

import Events from "@/utils/Events";
import { GET_OFFER_TYPE } from "@/store/slices/offerSlice";
import {isValidCookie} from "@/interfaces/CookieOespInfo";
import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { useRouter } from "next/router";

const Separator = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1rem 0;
`;

const Line = styled.hr`
  flex: 1;
  border: none;
  border-top: 1px solid #ddd;
`;

const COOKIE_ERRO_LOGIN_SOCIAL = "OESP_LOGIN_SOCIAL_ERRO"

const CallToSocialLogin = styled.span`
  margin: 0 0.5rem;
  color: #999;
  font-size: 0.75rem;
  font-weight: 500;
`
const BTNSocial = styled.a`
  padding: 0;
  cursor: pointer;
  display: flex;
  width: 100%;
  height: 44px;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: #1f1f1f;

  img, svg {
    color: ${themes.estadaoDark};
    margin-right: 10px;
  }

  border-radius: 5px;
  border: solid 1px #d3d3d3;
`
export default function ContinuarRedesSociais() {
    const [cookies, setCookie, removeCookie] = useCookies();
    const dispatch = useDispatch()
    const offer_type = useSelector(GET_OFFER_TYPE)
    const router = useRouter();

    const events = new Events();

    const [ticket, setTicket] = useState<string | string[] | undefined>('')

    function setEventsOnButton(event: string) {
        if(event === "google"){
            events.trigger("identificacao_login_google",{ offer_type })
        }
        if(event === "apple"){
          events.trigger("identificacao_login_apple",{ offer_type })
        }   
        if(event === "facebook"){
            events.trigger("identificacao_login_facebook",{ offer_type })
        }
    }

    function ValidateTelefone(telefone: any) {
        return telefone && telefone.trim().length >= 8
    }

    const appleDivRef = useRef(null);

    useEffect(() => {
      if (router.isReady) {
        setTicket(router.query['ticket-apple'])
      }
    }, [router.isReady, router.query]);

    useEffect(() => {

      if (!(window as any).AppleID) {
        const script = document.createElement("script");
        script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        script.async = true;
        script.onload = initializeApple;
        document.body.appendChild(script);
      } else {
        initializeApple();
      }
    }, []);

    const initializeApple = () => {
        (window as any).AppleID.auth.init({
            clientId: 'br.com.estadao.noticias.login',
            scope: 'name email',
            redirectURI:'https://reactjs-arqt-assine-3-dev.estadao.com.br/checkout/estadao-digital-completa-19990-aa170074',
            usePopup: true
          });
    };

    const handleAppleLogin = async () => {
      setEventsOnButton('apple')
      try {
        const data = await (window as any).AppleID.auth.signIn();
        const { authorization, user } = data;
        const res = await fetch("https://api-login-dev.estadao.com.br/login/apple", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            redirect_uri:'https://reactjs-arqt-assine-3-dev.estadao.com.br/checkout/estadao-digital-completa-19990-aa170074',
            code: authorization.code,
            user: user || null,
            set_cookies: true,
            with_cookie: true,
            web: true
          }),
        });

        const result = await res.json();
        if (result.id) {
          result.cookies.forEach((cookie: {
            name: string;
            value: string;
            path?: string;
            expires?: string | number | Date;
            secure?: boolean;
            domain?: string;
          }) => {
            let decodedValue = cookie.value;
            try {
              decodedValue = decodeURIComponent(cookie.value);
            } catch (e) {
              console.log(`Valor de cookie ${cookie.name} não pôde ser decodificado. Usando valor original.`);
            }
        
            setCookie(cookie.name, decodedValue, {
              path: cookie.path ?? '/',
              domain: cookie.domain ?? '.estadao.com.br',
              expires: cookie.expires ? new Date(cookie.expires) : undefined,
              secure: !!cookie.secure
            });
          });
        
          let interval = setInterval(() => {
            const rawCookie = Cookie.get("OESP_INFO");
            if (rawCookie) {
              try {
                const decoded = decodeURIComponent(rawCookie);
                const cookie = JSON.parse(decoded);
        
                const oesp_info = {
                  id: cookie.id,
                  email: cookie.email,
                  nome: cookie.nome,
                  sobre_nome: cookie.sobre_nome,
                  cpf: cookie.cpf,
                };
        
                cookie.assinante =
                  cookie.produtos &&
                  cookie.produtos.length > 0 &&
                  cookie.produtos.indexOf("Not_") > -1;
        
                if (isValidCookie(oesp_info)) {
                  dispatch(SET_USER(cookie));
        
                  if (!ValidateTelefone(cookie.telefone)) {
                    window.location.reload();
                  } else {
                    dispatch(SET_USER_STEP(2));
                  }
        
                  clearInterval(interval);
                }
              } catch (err) {
                console.error("Erro ao processar OESP_INFO:", err);
                clearInterval(interval);
              }
            }
          }, 1000);
        }     
      } catch (error:any) {
        console.log(error)
      }
    };

    function socialLogin(e: any) {
        e.preventDefault();

        const social = e.currentTarget.dataset.social;

        setEventsOnButton(social);

        let windowSize = {
            width: 500,
            height: 600,
        };


        const window_signin = window.open(e.currentTarget.href, '_blank', [
            "toolbar=no",
            "scrollbars=no",
            "resizable=no",
            "width=" + windowSize.width,
            "height=" + windowSize.height
        ].join(", "));

        if (!window_signin) {
            if (social === 'google') {
                events.trigger("identificacao_login_google_popup_bloqueado", { offer_type })
            }
            return
        }

        let interval = setInterval(() => {
            if (window_signin.closed || typeof window_signin.closed === 'undefined') {
                clearInterval(interval);

                if (Cookie.get("OESP_INFO") && Cookie.get("OESP_INFO") !== null) {
                    let cookie: any = {}
                    try {
                        cookie = JSON.parse(Cookie.get('OESP_INFO') ?? '{}')
                    } catch (err) {
                        console.error("Erro ao processar OESP_INFO:", err)
                    }

                    const oesp_info = {
                        id: cookie.id,
                        email: cookie.email,
                        nome: cookie.nome,
                        sobre_nome: cookie.sobre_nome,
                        cpf: cookie.cpf,
                    }
                    cookie.assinante = cookie.produtos && cookie.produtos.length > 0 && cookie.produtos.indexOf('Not_') > -1
                    if (isValidCookie(oesp_info)) {
                        if (social === 'google') {
                            events.trigger("identificacao_login_google_sucesso", { offer_type })
                        }

                        dispatch(SET_USER(cookie))

                        if (!ValidateTelefone(cookie.telefone)) {
                            window.location.reload()
                        }else{
                            dispatch(SET_USER_STEP(2))
                        }
                    } else if (social === 'google') {
                        events.trigger("identificacao_login_google_erro", { offer_type, motivo: 'cookie_invalido' })
                    }
                } else if (social === 'google') {
                    // Sem OESP_INFO: se o acesso sinalizou falha é erro, senão o usuário fechou o popup
                    const motivo = Cookie.get(COOKIE_ERRO_LOGIN_SOCIAL)
                    if (motivo) {
                        removeCookie(COOKIE_ERRO_LOGIN_SOCIAL, { path: '/', domain: '.estadao.com.br' })
                        events.trigger("identificacao_login_google_erro", { offer_type, motivo })
                    } else {
                        events.trigger("identificacao_login_google_cancelado", { offer_type })
                    }
                }
            }
        }, 1000);
    }
    return (
        <div className={'text--center'}>
            <SimpleText color={'#000'} linkColor={themes.estadao}>
                Ao clicar em continuar você estará concordando com os <br/>
                <a href={AppEnum.TERMOS_USO} target={"_blank"} onClick={()=>events.trigger("identificacao_termos_de_uso",{ offer_type })}>Termos de Uso e</a>  <a
                href={AppEnum.POLITICA_PRIVACIDADE} target={"_blank"} onClick={()=>events.trigger("identificacao_politica_de_privacidade",{ offer_type })}>Política de Privacidade</a>
            </SimpleText>
            <Separator>
              <Line />
              <CallToSocialLogin>ou</CallToSocialLogin>
              <Line />
            </Separator>
            
            <div className="col" style={{padding:'0'}}>
              {ticket &&
                 <div>
                    <BTNSocial style={{backgroundColor: "black", color:'white'}} data-transaction-name="Login com apple" className="btn apple" data-social='apple'
                             ref={appleDivRef}  onClick={handleAppleLogin}> <svg  height="20" viewBox="0 0 14 17" style={{verticalAlign: 'middle', marginRight: '10px'}}>
                             <path fill="white" d="M12.28 8.22c-.01-2.17 1.77-3.2 1.85-3.25-1.01-1.47-2.59-1.68-3.15-1.71-1.34-.14-2.62.79-3.3.79-.68 0-1.73-.77-2.84-.75-1.46.02-2.81.85-3.56 2.15-1.51 2.63-.39 6.53 1.08 8.66.71 1.01 1.56 2.13 2.67 2.09 1.07-.04 1.47-.67 2.76-.67 1.29 0 1.65.67 2.77.65 1.15-.02 1.87-1.03 2.56-2.05.81-1.18 1.14-2.34 1.15-2.4-.03-.01-2.21-.85-2.24-3.37zm-2.1-6.22c.61-.74 1.02-1.77.9-2.8-.87.04-1.92.58-2.54 1.31-.56.66-1.05 1.72-.92 2.73.97.08 1.95-.49 2.56-1.24z"/>
                           </svg>Continuar com a Apple</BTNSocial>
                </div>
              }

                <div style={{marginTop: '12px'}}>
                    <BTNSocial style={{backgroundColor: "white"}} data-transaction-name="Login com google" className="btn google" data-social='google'
                               href={"https://acesso.estadao.com.br/login/logout?r=" + encodeURIComponent("https://acesso.estadao.com.br/login/autenticar?provider=Google&conectado=1&r=close")}
                               onClick={socialLogin}><Image src={'/imgs/logo-google.svg'} alt={'logo-google'} width={20}
                                height={20}></Image>Continuar com o Google</BTNSocial>
                </div>
                {/* <div className="col-6">
                    <BTNSocial data-transaction-name="Login com facebook" className="btn facebook" data-social='facebook'
                               href={"https://acesso.estadao.com.br/login/logout?r=" + encodeURIComponent("https://acesso.estadao.com.br/login/autenticar?provider=Facebook&conectado=1&r=close")}
                               onClick={socialLogin}><Icon path={mdiFacebook} size={1}></Icon> Facebook</BTNSocial>
                </div> */}
            </div>
        </div>
    )
}
